class PdpUpsells extends HTMLElement {
  constructor() {
    super();

    this.upsellProducts = this.querySelectorAll(".pdp-upsells .pdp-upsells_product");
    this.accordionButton = this.querySelector(".pdp-upsells .accordion-trigger");
    this.accordionButtonContent = this.querySelector(".pdp-upsells .accordion-trigger span:not(.animated-icon-plus)");
    this.accordionContent = this.querySelector(".pdp-upsells .accordion-content");

    this.accordionCopyMore = this.dataset.accordionCopyMore;
    this.accordionCopyLess = this.dataset.accordionCopyLess;
  }

  connectedCallback() {
    this.upsellProducts.forEach((product) => {
      product.addEventListener("click", (e) => {
        this.handleSwatchChange.bind(this)(e);
      });
    });

    // collapsed accordion content is only hidden visually, so make it inert to
    // keep the hidden card's product link and add to bag button out of tab order
    if (this.accordionContent !== null && this.accordionContent.getAttribute("aria-hidden") === "true") {
      this.accordionContent.inert = true;
    }

    if (this.accordionButton === null) return;
    this.accordionButton.addEventListener("click", (e) => {
      this.handleAccordionClick.bind(this)(e);
    });
  }

  handleSwatchChange(e) {
    const clickedEl = e.target;

    if(!clickedEl.classList.contains("colour-circle")) return;

    const parentEl = clickedEl.closest(".pdp-upsells_product");
    const allSwatchesEl = parentEl.querySelectorAll(".colour-circle");

    const imageEl = parentEl.querySelector(".upsell-media img");
    const titleEl = parentEl.querySelector(".upsell-title");
    const priceEl = parentEl.querySelector(".upsell-price");
    const compareAtPriceEl = parentEl.querySelector(".upsell-price.compare-at");

    const mediaLinkEl = parentEl.querySelector("a.upsell-media");
    const titleLinkEl = parentEl.querySelector(".upsell-title-link");
    const variantIdEl = parentEl.querySelector(".upsell-product-form input[name='id']");
    const submitEl = parentEl.querySelector(".upsell-add-to-bag");
    const submitProductNameEl = parentEl.querySelector(".upsell-add-to-bag__product");

    const productImage = clickedEl.dataset.featuredImage;
    const productTitle = clickedEl.dataset.productTitle;
    const productPrice = clickedEl.dataset.productPrice;
    const productCompareAtPrice = clickedEl.dataset.productCompareAtPrice;
    const shouldShowCompareAtPrice = clickedEl.dataset.shouldShowCompareAtPrice === "true";
    const productUrl = clickedEl.dataset.productUrl;
    const productAvailable = clickedEl.dataset.available === "true";

    allSwatchesEl.forEach((swatch) => {
      swatch.classList.remove("selected");
    });
    clickedEl.classList.add("selected");

    imageEl.src = productImage;
    imageEl.srcset = productImage;
    // alt names the media link, so it has to follow the selected colour too
    imageEl.alt = productTitle;
    // the title text sits inside the link, so only replace the link's text node
    if (titleLinkEl) {
      titleLinkEl.childNodes[0].nodeValue = productTitle;
    } else {
      titleEl.innerHTML = productTitle;
    }
    priceEl.innerHTML = productPrice;
    if (shouldShowCompareAtPrice) {
      compareAtPriceEl.innerHTML = productCompareAtPrice;
      compareAtPriceEl.classList.remove("hidden");
    } else {
      compareAtPriceEl.classList.add("hidden");
    }

    // re-point the links and the add to bag form at the newly selected product
    if (mediaLinkEl) mediaLinkEl.href = productUrl;
    if (titleLinkEl) titleLinkEl.href = productUrl;
    if (variantIdEl) variantIdEl.value = clickedEl.dataset.productId;
    if (submitEl) submitEl.disabled = !productAvailable;

    // keep the screen reader only product title in step with the selected colour
    if (submitProductNameEl && productTitle) {
      submitProductNameEl.textContent = productTitle;
    }
  }

  handleAccordionClick() {

    const ariaExpanded = this.accordionButton.getAttribute("aria-expanded");
    if (ariaExpanded === "false") {
        this.accordionButton.setAttribute("aria-expanded", "true");
        this.accordionContent.setAttribute("aria-hidden", "false");
        this.accordionContent.inert = false;
        this.accordionButtonContent.innerHTML = this.accordionCopyLess;
    } else {
        this.accordionButton.setAttribute("aria-expanded", "false");
        this.accordionContent.setAttribute("aria-hidden", "true");
        this.accordionContent.inert = true;
        this.accordionButtonContent.innerHTML = this.accordionCopyMore;
    }
  }
}

customElements.define("pdp-upsells", PdpUpsells);
